<template>
    <section class="print-pdf">
        <template v-if="this.postsSortByImpression && graphData && pageStats !== null && pageStats && pageStats.page && pageStats.page.previous_period && currentPage && getPreviousPeriod && graphLabels && dateStart && dateEnd">
      
            <div class="slide slide1">
                <SlideHome :PageName="currentPage.name" :Network="currentPage.network" :DateStart="new Date(dateStart)" :DateEnd="new Date(dateEnd)" :PictureUrl="currentPage.avatar"></SlideHome>
            </div>
            <!-- <div class="slide slide2">
                <SlideTitleSection :Title="'Analyse de la visibilité'" :SubTitle="'Mesurez votre impact en analysant vos<br>activités du profil Instagram'" :DateStart="new Date(dateStart)" :DateEnd="new Date(dateEnd)" :PictureUrl="currentPage.avatar"></SlideTitleSection>
            </div> -->
            <div class="slide slide3" v-if="['facebook','linkedin','instagram','tiktok'].includes(currentPage.network)">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.visibility.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.visibility.main.subSectionName')" :Description="'Analyse de votre visibilité au cours de la période sélectionnée'" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <SlideResumeSection v-if="graphData && pageStats && pageStats.page" :Items="getDataSlide[3].dataResume"></SlideResumeSection>
            </div>
            <div class="slide slide4" v-if="['facebook','instagram','tiktok'].includes(currentPage.network) && getDataSlide[4] && getDataSlide[4].dataGraph[0].data.length">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.visibility.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.visibility.followers.subSectionName')" :Description="this.$t('dash.reporting.pdf.visibility.followers.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <Graph :id="'graph_daily_follows'" :data="getDataSlide[4].dataGraph" :labels="graphLabels" :width="'1324px'" :height="'644.4px'"></Graph>
                <div class="text-data">
                    <ComponentTab  
                        :values="getDataSlide[4].dataTab.values"
                        :totals="getDataSlide[4].dataTab.totals">
                    </ComponentTab>

                    <ComponentTextResume 
                        :title="getDataSlide[4].dataTextResume.title" 
                        :value="getDataSlide[4].dataTextResume.value" 
                        :label="getDataSlide[4].dataTextResume.label" 
                        :pourcentage="getDataSlide[4].dataTextResume.pourcentage" 
                        :DateStart="new Date(getPreviousPeriod.start.split('/').reverse().join('-'))" 
                        :DateEnd="new Date(getPreviousPeriod.end.split('/').reverse().join('-'))">
                    </ComponentTextResume>
                </div>
            </div>
            <div class="slide slide5" v-if="['facebook','linkedin','instagram','tiktok'].includes(currentPage.network)">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.visibility.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.visibility.interaction.subSectionName')" :Description="this.$t('dash.reporting.pdf.visibility.interaction.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <Graph :id="'graph_interaction'" 
                    :data="getDataSlide[5].dataGraph" 
                    :labels="graphLabels"
                    :height="'658px'"
                    :width="'1324px'">
                </Graph>
                <div class="text-data">
                    <ComponentTab
                        :values="getDataSlide[5].dataTab.values"
                        :totals="getDataSlide[5].dataTab.totals">
                    </ComponentTab>

                    <ComponentTextResume 
                        :title="getDataSlide[5].dataTextResume.title" 
                        :value="getDataSlide[5].dataTextResume.value" 
                        :label="getDataSlide[5].dataTextResume.label" 
                        :pourcentage="getDataSlide[5].dataTextResume.pourcentage" 
                        :DateStart="new Date(getPreviousPeriod.start.split('/').reverse().join('-'))" 
                        :DateEnd="new Date(getPreviousPeriod.end.split('/').reverse().join('-'))">
                    </ComponentTextResume>
                </div>
            </div>
            <div class="slide slide6" v-if="['facebook', 'tiktok'].includes(currentPage.network) && pageStats.page.impression_posts_graph">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.visibility.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.visibility.print.subSectionName')" :Description="this.$t('dash.reporting.pdf.visibility.print.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <Graph :id="'graph_impression'"
                    :data="pageStats ? [
                    {data: pageStats.page.impression_posts_graph.map((d, index) => d.total), label: $t('dash.reporting.impression'), type: 'line'},
                    ] : []"
                    :labels="graphLabels"
                    :height="'762px'"
                    :width="'1324px'">
                </Graph>
                <div class="text-data">
                    <ComponentTextResume  v-if="graphData && pageStats && pageStats.page"
                        :title="'Le total est de'"
                        :value="pageStats.page.totalImpressions.toString()"
                        :label="'impressions'"
                        :pourcentage="pageStats.page.previous_period && pageStats.page.previous_period.totalImpressions ? Math.round((pageStats.page.totalImpressions - pageStats.page.previous_period.totalImpressions) / pageStats.page.previous_period.totalImpressions * 100,2) : 0"
                        :DateStart="new Date(getPreviousPeriod.start.split('/').reverse().join('-'))"
                        :DateEnd="new Date(getPreviousPeriod.end.split('/').reverse().join('-'))">
                    </ComponentTextResume>
                </div>
            </div>  
            <div class="slide slide7"  v-if="['instagram'].includes(currentPage.network) && getDataSlide[7]">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.visibility.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.visibility.demographicData.subSectionName')" :Description="this.$t('dash.reporting.pdf.visibility.demographicDataAll.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <div class="persona">
                    <ComponentTextPersona  v-if="graphData && pageStats && pageStats.page" :stats="pageStats.page"></ComponentTextPersona> 
                    <Graph2 :id="'stat-gender'" :data="getDataSlide[7].dataGraphGenderValues" :labels="getDataSlide[7].dataGraphGenderLabels" :width="'600px'"></Graph2>
                    <Graph2 :id="'stat-age'" :data="getDataSlide[7].dataGraphAgeValues" :labels="getDataSlide[7].dataGraphAgeLabels" :width="'600px'"></Graph2>
                </div>
            </div>
            <div class="slide slide8" v-if="['facebook','instagram','tiktok'].includes(currentPage.network) && getDataSlide[8] && getDataSlide[8].dataGraph">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.visibility.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.visibility.demographicData.subSectionName')" :Description="this.$t('dash.reporting.pdf.visibility.demographicDataCountry.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <div class="map">
                    <MapChart
                        :countryData="getDataSlide[8].dataGraph"
                        highColor="rgba(106, 31, 76, 1)"
                        lowColor="rgba(106, 31, 76, 0.1)"
                        countryStrokeColor="#ffffff"
                        defaultCountryFillColor="#dadada"
                        :LangUser="$i18n.locale"
                        :currencyAdd="false"
                    />
                </div>
                <div class="legendMap">
                    <p v-for="countryData in Object.entries(getDataSlide[8].dataGraph).slice().sort((a,b)=> parseFloat(b[1]) - parseFloat(a[1])).slice(0,3)" :key="countryData[0]">
                        {{ country[countryData[0]] }}
                        <span>({{ countryData[1] }}%)</span>
                    </p>
                </div>
            </div>  
            <div class="slide slide9" v-if="currentPage.network === 'tiktok' && getDataSlide[9] && getDataSlide[9].dataGraphGenderAge && getDataSlide[9].dataGraphGenderAge.length">
                <ComponentHeader :SectionName="this.$t('dash.reporting.pdf.visibility.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.visibility.demographicData.subSectionName')" :Description="this.$t('dash.reporting.pdf.visibility.demographicDataAll.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <div class="demographic-content">
                    <div class="demographic-graph">
                        <Graph
                            :id="'graph_demographic_tiktok'"
                            :data="getDataSlide[9].dataGraphGenderAge"
                            :labels="getDataSlide[9].labels"
                            :height="'600px'"
                            :width="'800px'">
                        </Graph>
                    </div>
                    <div class="demographic-gender" v-if="getDataSlide[9].fansByGender && getDataSlide[9].fansByGender.length">
                        <componentGraph
                            :data="[{
                                name: 'fans_by_gender',
                                type: 'doughnut',
                                data: getDataSlide[9].fansByGender.map(item => typeof item === 'object' ? (item.value || item.total || 0) : item),
                                color: ['#4c34e5', '#e53481', '#df34e5']
                            }]"
                            :state="['0']"
                            :labels="[$t('page_follows_by_gender_male'), $t('page_follows_by_gender_female'), $t('page_follows_by_gender_undefined')]"
                            :section="'pdf_gender_tiktok'"
                        />
                    </div>
                </div>
            </div>
            <div class="slide slide9" v-if="['facebook','instagram'].includes(currentPage.network)">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.visibility.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.visibility.demographicData.subSectionName')" :Description="this.$t('dash.reporting.pdf.visibility.demographicDataCoutryCity.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>

                <div v-if="getDataSlide[9]" class="stat-country-city">
                    <div class="country">
                        <h3>{{  this.$t('dash.reporting.pdf.visibility.demographicData.byCountry') }}</h3>
                        <Graph2 
                            :id="'stat-country'" 
                            :labels="getDataSlide[9].dataGraphCountryLabels.map(abr => (country[abr]))" 
                            :data="getDataSlide[9].dataGraphCountryValues"
                            :sufixLabel="'%'"
                            :height="'400px'"
                            :width="'637px'"
                        >
                        </Graph2>
                    </div>
                    <div class="city">
                        <h3>{{  this.$t('dash.reporting.pdf.visibility.demographicData.byCity') }}</h3>
                        <Graph2 
                            :id="'stat-city'"
                            :labels="getDataSlide[9].dataGraphCityLabels" 
                            :data="getDataSlide[9].dataGraphCityValues"
                            :height="'400px'"
                            :width="'637px'"
                            >
                        </Graph2>
                    </div>
                </div>
                <div v-else class="data-not-found"><i class="fa-solid fa-magnifying-glass"></i><p>{{  $t('dash.reporting.pdf.dataNotFound') }}</p></div>
            </div>
            <!-- <div class="slide slide10" v-if="false && ['facebook'].includes(currentPage.network)">
                <SlideTitleSection :Title="'Analyse des publications'" :SubTitle="'Evaluer la performance des contenus<br>publiés sur votre profil Instagram'" :DateStart="new Date(dateStart)" :DateEnd="new Date(dateEnd)" :PictureUrl="currentPage.avatar"></SlideTitleSection>
            </div> -->
            <div class="slide slide11" v-if="['facebook'].includes(currentPage.network)">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.publication.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.publication.main.subSectionName')" :Description="this.$t('dash.reporting.pdf.publication.main.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <SlideResumeSection v-if="graphData && pageStats && pageStats.page" :Items="[
                    {
                        icon : 'fa-regular fa-square-plus', 
                        pourcentage : Math.round((pageStats.page.nb_posts - pageStats.page.previous_period.nb_posts) / pageStats.page.previous_period.nb_posts * 100), 
                        title : this.$t('dash.reporting.pdf.publication.sectionName'), 
                        value : pageStats.page.nb_posts
                    },
                    // {
                    //   icon : 'fa-solid fa-satellite-dish', 
                    //   pourcentage : pageStats.page.totalInteractions && pageStats.page.previous_period.totalInteractions ? Math.round((pageStats.page.totalInteractions - pageStats.page.previous_period.totalInteractions) / pageStats.page.previous_period.totalInteractions * 100) : 0, 
                    //   title : 'Portée des posts', 
                    //   value : pageStats && pageStats.page && pageStats.page.totalInteractions ? pageStats.page.totalInteractions : 0
                    // },
                    {
                        icon : 'fa-solid fa-eye', 
                        value : pageStats && pageStats.page && pageStats.page.totalImpressions ? pageStats.page.totalImpressions : 0,
                        pourcentage : pageStats && pageStats.page && pageStats.page.previous_period && pageStats.page.previous_period.totalImpressions && pageStats.page.totalImpressions ? Math.round((pageStats.page.totalImpressions - pageStats.page.previous_period.totalImpressions) / pageStats.page.previous_period.totalImpressions * 100) : 0, 
                        title : this.$t('dash.reporting.impression')
                    },
                    {
                        icon : 'fa-solid fa-hand-point-up', 
                        value : pageStats && pageStats.page && pageStats.page.totalInteractions ? pageStats.page.totalInteractions : 0,
                        pourcentage : pageStats && pageStats.page && pageStats.page.previous_period && pageStats.page.previous_period.totalInteractions && pageStats.page.totalInteractions ? Math.round((pageStats.page.totalInteractions - pageStats.page.previous_period.totalInteractions) / pageStats.page.previous_period.totalInteractions * 100) : 0, 
                        title : this.$t('dash.reporting.pdf.publication.interaction.subSectionName')
                    },
                ]"></SlideResumeSection>
            </div> 
            <div class="slide slide12" v-if="['facebook'].includes(currentPage.network)">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.publication.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.publication.interaction.subSectionName')" :Description="this.$t('dash.reporting.pdf.publication.interaction.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <Graph :id="'graph_type_post'" 
                    :data="pageStats ? [
                        //{data: this.getDataGraphPublication('snippet'), label: this.$t('dash.reporting.clic'), type: 'bar'}, 
                        {data: this.getDataGraphPublicationClick(), label: this.$t('dash.reporting.clic'), type: 'line'}, 
                        {data: this.getDataGraphPublication(), label: this.$t('dash.reporting.post'), type: 'bar'}, 
                    ] : []" 
                    :labels="graphLabels"
                    :height="'762px'"
                    :width="'1324px'">
                </Graph>
                <div class="text-data">
                    <ComponentTab v-if="graphData && pageStats && pageStats.page" 
                        :values="[
                            {
                                label : this.$t('dash.reporting.clic'),
                                // value : pageStats.posts.filter(p => p.type == 'snippet').length
                                value : pageStats.page.totalClicks
                            },

                            // {
                            //   label : 'Images',
                            //   value : pageStats.page.totalReactions
                            // },
                            // {
                            //   label : 'Video',
                            //   value : pageStats.page.totalComments
                            // },
                            // {
                            //   label : 'Carrousel (multi-media)',
                            //   value : pageStats.page.totalShares
                            // },
                            // {
                            //   label : 'Stories',
                            //   value : pageStats.page.totalClicks
                            // },
                            // {
                            //   label : 'Réels',
                            //   value : pageStats.page.totalClicks
                            // }
                            ]"
                        :totals="[
                            {
                                label : this.$t('dash.reporting.pdf.total'),
                                value : pageStats.page.nb_posts
                            },
                        
                        ]">
                    </ComponentTab>

                    <ComponentTextResume  v-if="graphData && pageStats && pageStats.page" 
                        :title="'Le nombre total est de'" 
                        :value="pageStats.page.nb_posts.toString()" 
                        :label="this.$t('dash.reporting.pdf.publications')" 
                        :pourcentage="Math.round((pageStats.page.nb_posts - pageStats.page.previous_period.nb_posts) / pageStats.page.previous_period.nb_posts * 100,2)" 
                        :DateStart="new Date(getPreviousPeriod.start.split('/').reverse().join('-'))" 
                        :DateEnd="new Date(getPreviousPeriod.end.split('/').reverse().join('-'))">
                    </ComponentTextResume>
                </div>
            </div>
            <div class="slide slide13" v-if="['facebook','linkedin','instagram','tiktok'].includes(currentPage.network) && pageStats.posts.length">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.publication.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.publication.top3.subSectionName')" :Description="this.$t('dash.reporting.pdf.publication.top.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <ComponentListCard
                    :posts="postsSortByImpression.slice(0,3)">
                </ComponentListCard>
            </div>
            <div class="slide slide14" v-if="['facebook','linkedin','instagram','tiktok'].includes(currentPage.network) && pageStats.posts.length">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.publication.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.publication.top15.subSectionName')" :Description="this.$t('dash.reporting.pdf.publication.top.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <ComponentListItem
                    :posts="postsSortByImpression"
                    :network="currentPage.network">
                </ComponentListItem>
            </div>
            <div class="slide slide15" v-if="['facebook','linkedin','tiktok'].includes(currentPage.network)">
                <ComponentHeader  :SectionName="this.$t('dash.reporting.pdf.publication.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.publication.bestMoment.subSectionName')" :Description="this.$t('dash.reporting.pdf.publication.bestMoment.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <GraphCalendar v-if="pageStats && pageStats.page && pageStats.page.optimalTimes && pageStats.page.optimalTimes.optimalTimeSlots"
                    :data="Object.values(pageStats.page.optimalTimes.optimalTimeSlots).map(dataHours => dataHours.map(hour => hour ? hour.totalReachEngagement : 0))"
                    :optimalTimes="pageStats.page.optimalTimes">
                </GraphCalendar>
                <div class="lengendCalendar">
                    <p>{{ this.$t('dash.reporting.pdf.publication.bestMoment.lessEngaging') }}</p>
                    <div></div><div></div><div></div><div></div><div></div>
                    <p>{{ this.$t('dash.reporting.pdf.publication.bestMoment.moreEngaging') }}</p>
                </div>
            </div>
            <div class="slide slide16" v-if="currentPage.network === 'tiktok' && pageStats.page.concurrences && pageStats.page.concurrences.length > 0">
                <ComponentHeader :SectionName="this.$t('dash.reporting.pdf.competitors.sectionName')" :SubSectionName="this.$t('dash.reporting.pdf.competitors.subSectionName')" :Description="this.$t('dash.reporting.pdf.competitors.description')" :Network="currentPage.network" :PictureUrl="currentPage.avatar"></ComponentHeader>
                <div class="competitors-table">
                    <table class="pdf-table">
                        <thead>
                            <tr>
                                <th>{{ $t('dash.reporting.section.concurrences.list.head.name') }}</th>
                                <th>{{ $t('dash.reporting.section.concurrences.list.head.follower_count') }}</th>
                                <th>{{ $t('dash.reporting.section.concurrences.list.head.follower_variation') }}</th>
                                <th>{{ $t('dash.reporting.section.concurrences.list.head.posts_count') }}</th>
                                <th>{{ $t('dash.reporting.section.concurrences.list.head.likes_count') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="main-page">
                                <td>{{ currentPage.name }}</td>
                                <td>{{ pageStats.page.page_follows && pageStats.page.page_follows.length ? numberSpacing(pageStats.page.page_follows[pageStats.page.page_follows.length - 1].total) : numberSpacing(pageStats.page.page_fans) }}</td>
                                <td :class="{ 'positive': pageStats.page.page_follows && pageStats.page.page_follows.length > 1 && pageStats.page.page_follows[pageStats.page.page_follows.length - 1].total - pageStats.page.page_follows[0].total > 0, 'negative': pageStats.page.page_follows && pageStats.page.page_follows.length > 1 && pageStats.page.page_follows[pageStats.page.page_follows.length - 1].total - pageStats.page.page_follows[0].total < 0 }">
                                    <template v-if="pageStats.page.page_follows && pageStats.page.page_follows.length > 1">
                                        {{ pageStats.page.page_follows[pageStats.page.page_follows.length - 1].total - pageStats.page.page_follows[0].total > 0 ? '+' : '' }}{{ numberSpacing(pageStats.page.page_follows[pageStats.page.page_follows.length - 1].total - pageStats.page.page_follows[0].total) }}
                                    </template>
                                    <template v-else>N/A</template>
                                </td>
                                <td>{{ numberSpacing(pageStats.page.page_post_count) }}</td>
                                <td>{{ numberSpacing(pageStats.page.page_likes) }}</td>
                            </tr>
                            <tr v-for="(concurrent, index) in pageStats.page.concurrences" :key="`pdf-concurrent-${index}`">
                                <td>{{ concurrent.concurrentName }}</td>
                                <td>{{ numberSpacing(concurrent.pageFollowers) }}</td>
                                <td :class="{ 'positive': concurrent.pageFollowersVariation > 0, 'negative': concurrent.pageFollowersVariation < 0 }">
                                    <template v-if="concurrent.pageFollowersVariation !== null && concurrent.pageFollowersVariation !== undefined">
                                        {{ concurrent.pageFollowersVariation > 0 ? '+' : '' }}{{ numberSpacing(concurrent.pageFollowersVariation) }}
                                    </template>
                                    <template v-else>N/A</template>
                                </td>
                                <td>{{ numberSpacing(concurrent.pagePostCount) }}</td>
                                <td>{{ numberSpacing(concurrent.pageLikes) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </section>
</template>


<script>
    import SlideHome from './SlideHome.vue'
    import SlideTitleSection from './SlideTitleSection.vue'
    import ComponentHeader from './ComponentHeader.vue'
    import SlideResumeSection from './SlideResumeSection.vue'
    import Graph from './Graph.vue'
    import Graph2 from './Graph2.vue'
    import GraphCalendar from './GraphCalendar.vue'
    import componentGraph from '../Graph'
    import ComponentTextResume from './ComponentTextResume.vue'
    import ComponentTab from './ComponentTab.vue'
    import ComponentTextPersona from './ComponentTextPersona.vue'
    import ComponentListCard from './ComponentListCard.vue'
    import ComponentListItem from './ComponentListItem.vue'
    import MapChart from 'vue-chart-map'
    import Moderation from './../../mixins/Moderation'

    import listCountry from './country_config.js'; // Importez les données des pays

    export default {
        components: {
            SlideHome,
            SlideTitleSection,
            ComponentHeader,
            SlideResumeSection,
            Graph,
            Graph2,
            ComponentTextResume,
            ComponentTab,
            ComponentTextPersona,
            ComponentListCard,
            ComponentListItem,
            GraphCalendar,
            componentGraph,
            MapChart,
        },
     
        mixins: [Moderation],
        props: {
            graphData: Array,
            pageStats: Object,
            currentPage: Object,
            getPreviousPeriod: Object,
            graphLabels: Array,
            dateStart : Number,
            dateEnd : Number
        },

        data() {
            return {
                postsSortByImpression : false,
                country: listCountry
            }
        },

        computed: {
            getDataSlide(){
                let data = Array(15);
          
                if (this.postsSortByImpression && this.graphData && this.pageStats !== null && this.pageStats && this.pageStats.page && this.pageStats.page.previous_period && this.currentPage && this.getPreviousPeriod && this.graphLabels && this.dateStart && this.dateEnd) {
                    switch (this.currentPage.network) {
                        case 'facebook':
                        
                            data[3] = {
                                dataResume : [
                                    {
                                        icon : 'fa-solid fa-user-group', 
                                        pourcentage : Math.round((this.graphData.find(g => g.name == 'page_follows').data[this.graphData.find(g => g.name == 'page_follows').data.length - 1] - this.pageStats.page.previous_period.page_follows[this.pageStats.page.previous_period.page_follows.length - 1].total) /  Math.max(this.pageStats.page.previous_period.page_follows[this.pageStats.page.previous_period.page_follows.length - 1].total,1) * 100), 
                                        title : this.$t('dash.reporting.pdf.followers'), 
                                        value : this.graphData.find(g => g.name == 'page_follows') ? this.graphData.find(g => g.name == 'page_follows').data[this.graphData.find(g => g.name == 'page_follows').data.length - 1] : 0
                                    },
                                    {
                                        icon : 'fa-solid fa-hand-point-up', 
                                        pourcentage : this.pageStats.page.totalInteractions && this.pageStats.page.previous_period.totalInteractions ? Math.round((this.pageStats.page.totalInteractions - this.pageStats.page.previous_period.totalInteractions) /  Math.max(this.pageStats.page.previous_period.totalInteractions,1) * 100) : 0, 
                                        title : this.$t('dash.reporting.pdf.publication.interaction.subSectionName'), 
                                        value : this.pageStats && this.pageStats.page && this.pageStats.page.totalInteractions ? this.pageStats.page.totalInteractions : 0
                                    },
                                    {
                                        icon : 'fa-solid fa-eye', 
                                        value : this.pageStats && this.pageStats.page && this.pageStats.page.totalImpressions ? this.pageStats.page.totalImpressions : 0,
                                        pourcentage : this.pageStats && this.pageStats.page && this.pageStats.page.previous_period && this.pageStats.page.previous_period.totalImpressions && this.pageStats.page.totalImpressions ? Math.round((this.pageStats.page.totalImpressions - this.pageStats.page.previous_period.totalImpressions) /  Math.max(this.pageStats.page.previous_period.totalImpressions,1) * 100) : 0, 
                                        title : this.$t('dash.reporting.pdf.visibility.print.subSectionName')
                                    },
                                ]
                            }  

                            data[4] = {
                                dataGraph : [{...this.graphData.find(g => g.name == 'page_follows'), type: 'line'},{...this.graphData.find(g => g.name == 'fans_evol'), type: 'line'}],
                                dataTab : {
                                values : [
                                    // {
                                    //     label : this.$t('dash.reporting.pdf.newFans'),
                                    //     value : this.pageStats.page.dailyPageFans_graph.reduce((prev, curr) => ({...prev, total : prev.total + curr.total})).total
                                    // },
                                    {
                                        label : this.$t('dash.reporting.pdf.newFollowers'),
                                        value : this.graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr)
                                    }
                                ],
                                total : [{
                                    label : this.$t('dash.reporting.pdf.totalFollowers'),
                                    value : this.graphData.find(g => g.name == 'page_follows') ? this.graphData.find(g => g.name == 'page_follows').data[this.graphData.find(g => g.name == 'page_follows').data.length - 1] : 0
                                }]
                                },
                                dataTextResume : {
                                title : this.$t('dash.reporting.pdf.totalAudience'),
                                value: this.graphData.find(g => g.name == 'page_follows') ? this.graphData.find(g => g.name == 'page_follows').data[this.graphData.find(g => g.name == 'page_follows').data.length - 1].toString() : '0',
                                label: this.$t('dash.reporting.pdf.followers'),
                                pourcentage: Math.abs(Math.round((this.graphData.find(g => g.name == 'page_follows').data[this.graphData.find(g => g.name == 'page_follows').data.length - 1] - this.pageStats.page.previous_period.page_follows[this.pageStats.page.previous_period.page_follows.length - 1].total) / this.pageStats.page.previous_period.page_follows[this.pageStats.page.previous_period.page_follows.length - 1].total * 100)),
                                }
                            }

                            data[5] = {
                                dataGraph : [
                                    {data: this.pageStats.page.page_post_engagements.map((d, index) => this.pageStats.page.impression_posts_graph[index] ? (d.total / this.pageStats.page.impression_posts_graph[index].total*100).toFixed(2) : 0), label:'Taux d’engagement par impression', type: 'line'},
                                    {data: this.pageStats.page.sharesGraph.map(d=>(d.total)), label:this.$t('dash.label.fb.shares'), type: 'bar'},
                                    {data: this.pageStats.page.commentsGraph.map(d=>(d.total)), label:this.$t('dash.reporting.comments'), type: 'bar'},
                                    {data: this.pageStats.page.reactionsGraph.map(d=>(d.total)), label:this.$t('dash.reporting.pdf.reactions'), type: 'bar'},
                                    {data: this.pageStats.page.link_clicks_graph.map(d=>(d.total)), label:this.$t('dash.reporting.clic'), type: 'bar'},
                                ],
                                dataTab : {
                                    values : [
                                        {
                                            label : this.$t('dash.reporting.pdf.reactions'),
                                            value : this.pageStats.page.totalReactions
                                        },
                                        {
                                            label : this.$t('dash.reporting.pdf.comments'),
                                            value : this.pageStats.page.totalComments
                                        },
                                        {
                                            label : this.$t('dash.reporting.pdf.shares'),
                                            value : this.pageStats.page.totalShares
                                        },
                                        {
                                            label : this.$t('dash.reporting.pdf.clics'),
                                            value : this.pageStats.page.totalClicks
                                        }
                                    ],
                                    totals : [
                                        {
                                            label : this.$t('dash.reporting.pfp.totalInteractions'),
                                            value : this.pageStats.page.totalInteractions
                                        },
                                        {
                                            label : this.$t('dash.reporting.pdf.engagementRate'),
                                            value : Math.round(this.pageStats.page.totalInteractions/Math.max(1,this.pageStats.page.totalImpressions)*100)+'%'
                                        },
                                    ]
                                },
                                dataTextResume : {
                                    title : this.$t('dash.reporting.pdf.totalEngagementRate'),
                                    value: Math.round(this.pageStats.page.totalInteractions/Math.max(this.pageStats.page.totalImpressions,1)*100,2)+'%',
                                    label: this.$t('dash.reporting.pdf.byPrint'),
                                    pourcentage: Math.round((this.pageStats.page.totalInteractions/Math.max(this.pageStats.page.totalImpressions,1) - this.pageStats.page.previous_period.totalInteractions/Math.max(1,this.pageStats.page.previous_period.totalImpressions)) / Math.max(1,this.pageStats.page.previous_period.totalInteractions / Math.max(1,this.pageStats.page.previous_period.totalImpressions)) * 100,2)
                                }
                            }
                            
                            if (this.pageStats.page.page_follows_country_percent && this.pageStats.page.page_follows_city) {
                                data[8] = { 
                                    dataGraph : this.pageStats.page.page_follows_country_percent
                                }
                            }

                            if (this.pageStats.page.page_follows_country_percent) {
                                data[9] = {
                                    dataGraphCountryLabels : Object.entries(this.pageStats.page.page_follows_country_percent).slice().sort((a,b)=> parseFloat(b[1])-parseFloat(a[1])).slice(0,6).map(v => v[0]),
                                
                                    dataGraphCountryValues : [
                                        {
                                            data: Object.entries(this.pageStats.page.page_follows_country_percent).slice().sort((a,b)=> parseFloat(b[1])-parseFloat(a[1])).slice(0,6).map(v => v[1]),
                                            label: this.$t('dash.reporting.pdf.followers')+' (%)',
                                            type: 'bar'
                                        }
                                    ],
                                    // dataGraphCityLabels : (this.pageStats.page.page_follows_city).slice().sort((a,b)=> b.value-a.value).slice(0,6).map(v => v.name),
                                    // dataGraphCityValues : [
                                    //     {
                                    //         data: (this.pageStats.page.page_follows_city).slice().sort((a,b)=> b.value-a.value).slice(0,6).map(v => v.value),
                                    //         label: this.$t('dash.reporting.pdf.followers'),
                                    //         type: 'bar'
                                    //     }
                                    // ]
                                }
                                if(this.pageStats.page.page_follows_city){
                                    data[9].dataGraphCityLabels =  (this.pageStats.page.page_follows_city).slice().sort((a,b)=> b.value-a.value).slice(0,6).map(v => v.name),
                                    data[9].dataGraphCityValues = [
                                        {
                                            data: (this.pageStats.page.page_follows_city).slice().sort((a,b)=> b.value-a.value).slice(0,6).map(v => v.value),
                                            label: this.$t('dash.reporting.pdf.followers'),
                                            type: 'bar'
                                        }
                                    ]
                                }
                            }
                           
                            break
                        
                        case 'linkedin':
                            data[3] = {
                                dataResume : [
                                {
                                    icon : 'fa-solid fa-user-group', 
                                    pourcentage : Math.round((this.pageStats.page.page_fans - this.pageStats.page.previous_period.page_fans) / Math.max(this.pageStats.page.previous_period.page_fans,1) * 100), 
                                    title : this.$t('dash.reporting.pdf.fans'), 
                                    value : this.pageStats.page.page_fans
                                },
                                {
                                    icon : 'fa-solid fa-hand-point-up', 
                                    pourcentage : Math.round(((this.pageStats.page.totalClicks + this.pageStats.page.totalComments + this.pageStats.page.totalReactions) - (this.pageStats.page.previous_period.totalClicks + this.pageStats.page.previous_period.totalComments + this.pageStats.page.previous_period.totalReactions)) / Math.max((this.pageStats.page.previous_period.totalClicks + this.pageStats.page.previous_period.totalComments + this.pageStats.page.previous_period.totalReactions),1) * 100), 
                                    title : this.$t('dash.reporting.pdf.interactions'), 
                                    value : this.pageStats.page.totalClicks + this.pageStats.page.totalComments + this.pageStats.page.totalReactions
                                },
                                {
                                    icon : 'fa-solid fa-eye', 
                                    value : this.pageStats && this.pageStats.page && this.pageStats.page.totalImpressions ? this.pageStats.page.totalImpressions : 0,
                                    pourcentage : Math.round((this.pageStats.page.totalImpressions - this.pageStats.page.previous_period.totalImpressions) / Math.max(this.pageStats.page.previous_period.totalImpressions,1) * 100), 
                                    title : this.$t('dash.reporting.pdf.print')
                                },
                                ]
                            }

                            data[5] = {
                                dataGraph : [
                                    {data: this.pageStats.page.impression_posts_graph.map((d, index) => ((this.pageStats.page.commentsGraph[index].total + this.pageStats.page.link_clicks_graph[index].total + this.pageStats.page.reactionsGraph[index].total) / Math.max(d.total,1) * 100).toFixed(2)), label:'Taux d’engagement par impression', type: 'line'},
                                    {data: this.pageStats.page.commentsGraph.map(d=>(d.total)), label:this.$t('dash.reporting.pdf.comments'), type: 'bar'},
                                    {data: this.pageStats.page.reactionsGraph.map(d=>(d.total)), label:this.$t('dash.reporting.pdf.reactions'), type: 'bar'},
                                    {data: this.pageStats.page.link_clicks_graph.map(d=>(d.total)), label: this.$t('dash.reporting.pdf.clics'), type: 'bar'},
                                ],
                                dataTab : {
                                    values : [
                                        {
                                            label : this.$t('dash.reporting.pdf.reactions'),
                                            value : this.pageStats.page.totalReactions
                                        },
                                        {
                                            label : this.$t('dash.reporting.pdf.comments'),
                                            value : this.pageStats.page.totalComments
                                        },
                                        {
                                            label : this.$t('dash.reporting.pdf.clics'),
                                            value : this.pageStats.page.totalClicks
                                        }
                                    ],
                                    totals : [
                                        {
                                            label : this.$t('dash.reporting.pfp.totalInteractions'),
                                            value : this.pageStats.page.totalClicks + this.pageStats.page.totalComments + this.pageStats.page.totalReactions
                                        },
                                        {
                                            label : this.$t('dash.reporting.pdf.engagementRate'),
                                            value : Math.round((this.pageStats.page.totalClicks + this.pageStats.page.totalComments + this.pageStats.page.totalReactions)/ Math.max(1,this.pageStats.page.totalImpressions)*100)+'%'
                                        },
                                    ]
                                },
                                dataTextResume : {
                                    title : this.$t('dash.reporting.pdf.totalEngagementRate'),
                                    value: Math.round((this.pageStats.page.totalClicks + this.pageStats.page.totalComments + this.pageStats.page.totalReactions)/Math.max(this.pageStats.page.totalImpressions,1)*100,2)+'%',
                                    label: this.$t('dash.reporting.pdf.byPrint'),
                                    pourcentage: Math.round(((this.pageStats.page.totalClicks + this.pageStats.page.totalComments + this.pageStats.page.totalReactions) - (this.pageStats.page.previous_period.totalClicks + this.pageStats.page.previous_period.totalComments + this.pageStats.page.previous_period.totalReactions)) / Math.max((this.pageStats.page.previous_period.totalClicks + this.pageStats.page.previous_period.totalComments + this.pageStats.page.previous_period.totalReactions),1) * 100,2), 
                                },            
                            }
                            break
                        case 'instagram':
                           

                            data[3] = {
                                dataResume : [
                                    {
                                        icon : 'fa-solid fa-user-group', 
                                        pourcentage : Math.round((this.pageStats.page.page_fans - this.pageStats.page.previous_period.page_fans) / Math.max(this.pageStats.page.previous_period.page_fans,1) * 100), 
                                        title : this.$t('dash.reporting.pdf.followers'), 
                                        value : this.pageStats.page.page_fans
                                    },
                                    {
                                        icon : 'fa-solid fa-hand-point-up', 
                                        pourcentage : Math.round((this.pageStats.page.totalInteractions - this.pageStats.page.previous_period.totalInteractions) / Math.max(this.pageStats.page.previous_period.totalInteractions,1) * 100), 
                                        title : this.$t('dash.reporting.pdf.interactions'), 
                                        value : this.pageStats.page.totalInteractions
                                    },
                                    {
                                        icon : 'fa-solid fa-eye', 
                                        value : this.pageStats && this.pageStats.page && this.pageStats.page.totalImpressions ? this.pageStats.page.totalImpressions : 0,
                                        pourcentage : Math.round((this.pageStats.page.totalImpressions - this.pageStats.page.previous_period.totalImpressions) / Math.max(this.pageStats.page.previous_period.totalImpressions,1) * 100), 
                                        title : this.$t('dash.reporting.pdf.print')
                                    },
                                ]
                            }

                            if(this.graphData.find(g => g.name == 'fans_win_lost') && this.graphData.find(g => g.name == 'fans_win_lost').data && this.graphData.find(g => g.name == 'fans_win_lost').data.length){
                                data[4] = {
                                    dataGraph : [{...this.graphData.find(g => g.name == 'fans_win_lost'), type: 'line'}],
                                    dataTab : {
                                        values : [{
                                            label : this.$t('dash.reporting.pdf.newFollowers'),
                                            value : this.graphData.find(g => g.name == 'fans_win_lost').data.reduce((prev, curr) => prev + curr)
                                            // value : this.pageStats.page.page_fans - this.pageStats.page.previous_period.page_fans
                                        }],
                                        total : [{
                                            label : this.$t('dash.reporting.pdf.totalFollowers'),
                                            value :  this.pageStats.page.page_fans
                                        }]
                                    },
                                    dataTextResume : {
                                        title : this.$t('dash.reporting.pdf.totalAudience'),
                                        value: this.pageStats.page.page_fans,
                                        label: this.$t('dash.reporting.pdf.followers'),
                                        pourcentage: Math.abs(Math.round((this.pageStats.page.page_fans - this.pageStats.page.previous_period.page_fans) / this.pageStats.page.previous_period.page_fans * 100)),
                                    }
                                }
                            }

                            data[5] = {
                                dataGraph : [
                                    {data: this.pageStats.page.impression_posts_graph.map((d, index) => ((this.pageStats.page.like_count_graph[index].total + this.pageStats.page.commentsGraph[index].total) / Math.max(1,d.total) * 100).toFixed(2)), label:'Taux d’engagement par impression', type: 'line'},
                                    {data: this.pageStats.page.commentsGraph.map(d=>(d.total)), label:'Commentaires', type: 'bar'},
                                    {data: this.pageStats.page.like_count_graph.map(d=>(d.total)), label:'Likes', type: 'bar'},
                                ],
                                dataTab : {
                                    values : [
                                        {
                                            label : 'Likes',
                                            value : this.pageStats.page.totalLikes
                                        },
                                        {
                                            label : this.$t('dash.reporting.pdf.comments'),
                                            value : this.pageStats.page.totalComments
                                        },

                                    ],
                                    totals : [
                                        {
                                            label : this.$t('dash.reporting.pfp.totalInteractions'),
                                            value : this.pageStats.page.totalInteractions
                                        },
                                        {
                                            label : this.$t('dash.reporting.pdf.engagementRate'),
                                            value : Math.round(this.pageStats.page.totalInteractions/Math.max(1,this.pageStats.page.totalImpressions)*100)+'%'
                                        },
                                    ]
                                },
                                dataTextResume : {
                                    title : this.$t('dash.reporting.pdf.totalEngagementRate'),
                                    value: Math.round(this.pageStats.page.totalInteractions/Math.max(this.pageStats.page.totalImpressions,1)*100,2)+'%',
                                    label: this.$t('dash.reporting.pdf.byPrint'),
                                    pourcentage: Math.round((this.pageStats.page.totalInteractions/Math.max(this.pageStats.page.totalImpressions,1) - this.pageStats.page.previous_period.totalInteractions/Math.max(1,this.pageStats.page.previous_period.totalImpressions)) / Math.max(1,this.pageStats.page.previous_period.totalInteractions / Math.max(1,this.pageStats.page.previous_period.totalImpressions)) * 100,2)
                                }
                            }

                            data[7] = this.pageStats.page.audience_gender_age ? {
                                dataGraphAgeValues: [
                                    {
                                        data: this.pageStats.page.audience_gender_age.map(v => v.value),
                                        label: this.$t('dash.reporting.section.demographie.aged'),
                                        type:'bar',
                                    }
                                ],
                                dataGraphAgeLabels: this.pageStats.page.audience_gender_age.map(v => v.name),
                                dataGraphGenderValues: [
                                    {
                                        data: this.pageStats.page.audience_gender.map(v => v.value),
                                        label: this.$t('dash.reporting.section.demographie.genre'),
                                        type:'bar',
                                    }
                                ],
                                dataGraphGenderLabels: this.pageStats.page.audience_gender.map(v => {
                                    if(v.name == 'M') return this.$t('dash.reporting.section.demographie.type_man')
                                    else if(v.name == 'F') return this.$t('dash.reporting.section.demographie.type_female')
                                    return this.$t('dash.reporting.section.demographie.type_undefined')
                                }),
                            } : null

                            data[8] = {
                                dataGraph : this.pageStats.page.audience_country_percent
                            }

                            if(this.pageStats.page.audience_country_percent) {
                                data[9] = {
                                    dataGraphCountryLabels : Object.entries(this.pageStats.page.audience_country_percent).slice().sort((a,b)=> parseFloat(b[1])-parseFloat(a[1])).slice(0,6).map(v => v[0]),
                
                                    dataGraphCountryValues : [
                                        {
                                            data: Object.entries(this.pageStats.page.audience_country_percent).slice().sort((a,b)=> parseFloat(b[1])-parseFloat(a[1])).slice(0,6).map(v => v[1]),
                                            label: this.$t('dash.reporting.pdf.followers')+' (%)',
                                            type: 'bar'
                                        }
                                    ],
                                    dataGraphCityLabels : (this.pageStats.page.audience_city).slice().sort((a,b)=> b.value-a.value).slice(0,6).map(v => v.name),
                                    dataGraphCityValues : [
                                        {
                                            data: (this.pageStats.page.audience_city).slice().sort((a,b)=> b.value-a.value).slice(0,6).map(v => v.value),
                                            label: this.$t('dash.reporting.pdf.followers'),
                                            type: 'bar'
                                        }
                                    ]
                                }
                            }
                            break
                        case 'tiktok': {
                            data[3] = {
                                dataResume: [
                                    {
                                        icon: 'fa-solid fa-user-group',
                                        pourcentage: this.pageStats.page.previous_period && this.pageStats.page.previous_period.page_fans
                                            ? Math.round((this.pageStats.page.page_fans - this.pageStats.page.previous_period.page_fans) / Math.max(this.pageStats.page.previous_period.page_fans, 1) * 100)
                                            : 0,
                                        title: this.$t('dash.reporting.pdf.followers'),
                                        value: this.pageStats.page.page_fans || 0
                                    },
                                    {
                                        icon: 'fa-regular fa-square-plus',
                                        pourcentage: this.pageStats.page.previous_period && this.pageStats.page.previous_period.nb_posts >= 0
                                            ? Math.round((this.pageStats.page.nb_posts - this.pageStats.page.previous_period.nb_posts) / Math.max(this.pageStats.page.previous_period.nb_posts, 1) * 100)
                                            : 0,
                                        title: this.$t('dash.posts.title'),
                                        value: this.pageStats.page.nb_posts || 0
                                    },
                                    {
                                        icon: 'fa-solid fa-eye',
                                        pourcentage: this.pageStats.page.previous_period && this.pageStats.page.previous_period.totalImpressions
                                            ? Math.round((this.pageStats.page.totalImpressions - this.pageStats.page.previous_period.totalImpressions) / Math.max(this.pageStats.page.previous_period.totalImpressions, 1) * 100)
                                            : 0,
                                        title: this.$t('dash.reporting.impression'),
                                        value: this.pageStats.page.totalImpressions || 0
                                    },
                                    {
                                        icon: 'fa-solid fa-comment',
                                        pourcentage: this.pageStats.page.previous_period && this.pageStats.page.previous_period.shareCommentCount >= 0
                                            ? Math.round((this.pageStats.page.shareCommentCount - this.pageStats.page.previous_period.shareCommentCount) / Math.max(this.pageStats.page.previous_period.shareCommentCount, 1) * 100)
                                            : 0,
                                        title: this.$t('dash.reporting.comment'),
                                        value: this.pageStats.page.shareCommentCount || 0
                                    },
                                    {
                                        icon: 'fa-solid fa-heart',
                                        pourcentage: this.pageStats.page.previous_period && this.pageStats.page.previous_period.shareLikeCount >= 0
                                            ? Math.round((this.pageStats.page.shareLikeCount - this.pageStats.page.previous_period.shareLikeCount) / Math.max(this.pageStats.page.previous_period.shareLikeCount, 1) * 100)
                                            : 0,
                                        title: this.$t('dash.reporting.like'),
                                        value: this.pageStats.page.shareLikeCount || 0
                                    },
                                    {
                                        icon: 'fa-solid fa-share',
                                        pourcentage: this.pageStats.page.previous_period && this.pageStats.page.previous_period.shareShareCount >= 0
                                            ? Math.round((this.pageStats.page.shareShareCount - this.pageStats.page.previous_period.shareShareCount) / Math.max(this.pageStats.page.previous_period.shareShareCount, 1) * 100)
                                            : 0,
                                        title: this.$t('dash.reporting.share'),
                                        value: this.pageStats.page.shareShareCount || 0
                                    },
                                    {
                                        icon: 'fa-solid fa-handshake-angle',
                                        pourcentage: this.pageStats.page.previous_period && this.pageStats.page.previous_period.totalReachEngag >= 0
                                            ? Math.round((this.pageStats.page.totalReachEngag - this.pageStats.page.previous_period.totalReachEngag) / Math.max(this.pageStats.page.previous_period.totalReachEngag, 0.01) * 100)
                                            : 0,
                                        title: this.$t('dash.reporting.engagemment'),
                                        value: (this.pageStats.page.totalReachEngag || 0).toFixed(2) + '%'
                                    }
                                ]
                            }

                            if (this.pageStats.page.page_follows && this.pageStats.page.page_follows.length > 0) {
                                const pageFollowsData = this.pageStats.page.page_follows.slice().sort((a, b) => a.date - b.date);
                                data[4] = {
                                    dataGraph: [{
                                        data: pageFollowsData.map(f => f.total),
                                        label: this.$t('dash.reporting.pdf.followers'),
                                        type: 'line'
                                    }],
                                    dataTab: {
                                        values: [{
                                            label: this.$t('dash.reporting.pdf.newFollowers'),
                                            value: this.pageStats.page.page_daily_follows_unique
                                                ? this.pageStats.page.page_daily_follows_unique.reduce((acc, d) => acc + d.total, 0)
                                                : 0
                                        }],
                                        totals: [{
                                            label: this.$t('dash.reporting.pdf.totalFollowers'),
                                            value: this.pageStats.page.page_fans || 0
                                        }]
                                    },
                                    dataTextResume: {
                                        title: this.$t('dash.reporting.pdf.totalAudience'),
                                        value: (this.pageStats.page.page_fans || 0).toString(),
                                        label: this.$t('dash.reporting.pdf.followers'),
                                        pourcentage: this.pageStats.page.previous_period && this.pageStats.page.previous_period.page_fans
                                            ? Math.abs(Math.round((this.pageStats.page.page_fans - this.pageStats.page.previous_period.page_fans) / Math.max(this.pageStats.page.previous_period.page_fans, 1) * 100))
                                            : 0
                                    }
                                }
                            }

                            data[5] = {
                                dataGraph: [
                                    {data: this.pageStats.page.like_count_graph ? this.pageStats.page.like_count_graph.map(d => d.total) : [], label: 'Likes', type: 'bar'},
                                    {data: this.pageStats.page.commentsGraph ? this.pageStats.page.commentsGraph.map(d => d.total) : [], label: this.$t('dash.reporting.pdf.comments'), type: 'bar'},
                                    {data: this.pageStats.page.sharesGraph ? this.pageStats.page.sharesGraph.map(d => d.total) : [], label: this.$t('dash.label.fb.shares'), type: 'bar'}
                                ],
                                dataTab: {
                                    values: [
                                        {label: 'Likes', value: this.pageStats.page.totalLikes || 0},
                                        {label: this.$t('dash.reporting.pdf.comments'), value: this.pageStats.page.totalComments || 0},
                                        {label: this.$t('dash.reporting.pdf.shares'), value: this.pageStats.page.totalShares || 0}
                                    ],
                                    totals: [
                                        {label: this.$t('dash.reporting.pfp.totalInteractions'), value: this.pageStats.page.totalInteractions || 0},
                                        {label: this.$t('dash.reporting.pdf.engagementRate'), value: Math.round((this.pageStats.page.totalInteractions || 0) / Math.max(this.pageStats.page.totalImpressions, 1) * 100) + '%'}
                                    ]
                                },
                                dataTextResume: {
                                    title: this.$t('dash.reporting.pdf.totalEngagementRate'),
                                    value: Math.round((this.pageStats.page.totalInteractions || 0) / Math.max(this.pageStats.page.totalImpressions, 1) * 100) + '%',
                                    label: this.$t('dash.reporting.pdf.byPrint'),
                                    pourcentage: this.pageStats.page.previous_period && this.pageStats.page.previous_period.totalImpressions
                                        ? Math.round(((this.pageStats.page.totalInteractions / Math.max(this.pageStats.page.totalImpressions, 1)) - (this.pageStats.page.previous_period.totalInteractions / Math.max(this.pageStats.page.previous_period.totalImpressions, 1))) / Math.max(this.pageStats.page.previous_period.totalInteractions / Math.max(this.pageStats.page.previous_period.totalImpressions, 1), 0.01) * 100)
                                        : 0
                                }
                            }

                            const fansCountryGraph = this.graphData ? this.graphData.find(g => g.name === 'fans_country') : null;
                            if (fansCountryGraph && fansCountryGraph.data) {
                                data[8] = {
                                    dataGraph: fansCountryGraph.data
                                }
                            }

                            const fansMaleAge = this.graphData ? this.graphData.find(g => g.name === 'fans_male_age') : null;
                            const fansFemaleAge = this.graphData ? this.graphData.find(g => g.name === 'fans_female_age') : null;
                            const fansUndefinedAge = this.graphData ? this.graphData.find(g => g.name === 'fans_undifined_age') : null;
                            const fansByGender = this.graphData ? this.graphData.find(g => g.name === 'fans_by_gender') : null;

                            if (fansMaleAge || fansFemaleAge || fansUndefinedAge) {
                                const labels = fansMaleAge ? fansMaleAge.labels : (fansFemaleAge ? fansFemaleAge.labels : []);

                                data[9] = {
                                    dataGraphGenderAge: [
                                        fansMaleAge ? {
                                            data: fansMaleAge.data,
                                            label: this.$t('dash.label.fb.male_age_fans'),
                                            type: 'bar',
                                            color: '#4c34e5'
                                        } : null,
                                        fansFemaleAge ? {
                                            data: fansFemaleAge.data,
                                            label: this.$t('dash.label.fb.female_age_fans'),
                                            type: 'bar',
                                            color: '#e53481'
                                        } : null,
                                        fansUndefinedAge ? {
                                            data: fansUndefinedAge.data,
                                            label: this.$t('dash.label.fb.undifined_age_fans'),
                                            type: 'bar',
                                            color: '#df34e5'
                                        } : null
                                    ].filter(g => g !== null),
                                    labels: labels,
                                    fansByGender: fansByGender ? fansByGender.data : null
                                }
                            }
                            break
                        }
                    }
                }

                return data
            }


        },

        methods: {
            numberSpacing(number) {
                if (number === null || number === undefined) return 'N/A';
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },
            getDataGraphPublication(type=null) {

                let data = Array(Math.ceil((this.dateEnd - this.dateStart) / 86400000)).fill(0);
                console.log("test31",data)
                this.pageStats.posts.forEach(post => {
                    // Calculer l'index dans data correspondant à la date de publication du post
                    if (!type || post.type == type) {

                        let index = Math.floor((post.date*1000 - this.dateStart) / 86400000);
                        console.log("test31",type,index)
                        if (index >= 0 && index < data.length) {
                            data[index]++;
                        }

                    }
                });
              
                return data
            },

            
            getDataGraphPublicationClick() {

                let data = Array(Math.ceil((this.dateEnd - this.dateStart) / 86400000)).fill(0);
                console.log("test31",data)
                this.pageStats.posts.forEach(post => {
                    // Calculer l'index dans data correspondant à la date de publication du post
                    if (post.link_clicks || post.total_clicks) {

                        let index = Math.floor((post.date*1000 - this.dateStart) / 86400000);
                        if (index >= 0 && index < data.length) {
                            data[index] += post.link_clicks || post.total_clicks;
                        }

                    }
                });

                return data
            },
        },

        watch: {
            'pageStats.posts': {
                async handler(newValue, oldValue) {
                    console.log('pageStats1',newValue)
                    if (newValue !== null && newValue.length) {
                        let sortedAndLimitedPosts =  this.pageStats.posts.slice().sort((a,b)=> (b.post_impressions ? b.post_impressions : 0) - (a.post_impressions ? a.post_impressions : 0)).slice(0,15)


                        if(['facebook','instagram','tiktok'].includes(this.currentPage.network))
                            await Promise.all(sortedAndLimitedPosts.map(async (post) => {
                                try {
                                    if (this.currentPage.network === 'tiktok') {
                                        post.attachment_url = post.attachment_url || post.cover_image_url;
                                    } else {
                                        const { body } = await this.getPostFromRS(this.currentPage, post.post_id, true);
                                        post.attachment_url = this.currentPage.network == 'facebook' ? body.post.full_picture : body.post.thumbnail_url || body.post.media_url;
                                    }
                                } catch (error) {
                                    console.error('Error fetching post data:', error);
                                }
                            }));

                        this.postsSortByImpression = sortedAndLimitedPosts;
                    }
                },
                immediate: true
            },
        },
    }
</script>
